import "./WelcomePage.scss";
import PublicationsGallery from "./components/PublicationsGallery";
import NavBar from "./components/NavBar";
import { useTranslation } from "react-i18next";
import { useQuery } from "hooks/useQuery";
import { CourseService } from "services/courseService";
import { Link } from "react-router-dom";
import {BackendServices} from "../../services";
import {useCookieContext} from "../../contexts";
import {SafeHtmlRenderer} from "../../components/safeHtmlRendererComponant/SafeHtmlRenderer";
import LoadingOverlay from "../../components/blocks/LoadingOverlay";

const WelcomePageView = () => {
  const { t } = useTranslation("WelcomePage");
  const { isAr } = useCookieContext();
  const { data, loading } = useQuery({
    queryFn: async () => {
      return await CourseService.getActiveCourse();
    },
  });
  const { data:welcomeWidget , loading: welcomeWidgetLoading } = useQuery({
    queryFn: async () => {
      return await BackendServices.widgetService.GetWidgetByReferenceId(process.env.REACT_APP_WELCOME_WIDGET);
    },
    triggers: [isAr],
  });

  const { data:headerWidget , loading: headerWidgetLoading } = useQuery({
    queryFn: async () => {
      return await BackendServices.widgetService.GetWidgetByReferenceId(process.env.REACT_APP_PUBLISHING_HEADER_PART_WIDGET);
    },
    triggers: [isAr],
  });

  return (
    <div className="w-100 bg-white d-flex flex-column">
      <div className="welcome-container text-white d-flex flex-column justify-content-between py-4 px-4rem ">
        <NavBar variant={"dark"} />
        <div className=" welcome-text-container d-flex flex-column gap-4 mb-5 align-items-start">
          <LoadingOverlay visible={welcomeWidgetLoading} position={"absolute"} />
            {welcomeWidget && <SafeHtmlRenderer htmlContent={welcomeWidget.widgetDetail.htmlTemplate} /> }
        </div>
      </div>
      <div className="publications-container px-4rem pt-4 pb-4rem text-dark">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <LoadingOverlay visible={headerWidgetLoading} position={"absolute"} />
            {headerWidget && <SafeHtmlRenderer htmlContent={headerWidget.widgetDetail.htmlTemplate} /> }
          </div>
          {!loading && !!data && (
            <Link to={`/course/${data}`} className="btn btn-primary p-10-32P rounded-3">
              {t("applyPublicationOrder")}
            </Link>
          )}
        </div>
        <PublicationsGallery />
      </div>
    </div>
  );
};

export default WelcomePageView;
